module.exports = __webpack_public_path__ + "img/Country.6c7089a2.svg";